import React from "react"
import MissingImage from "@/public/images/image-missing.png"
import arrowDown from "@/public/icons/arrow-down-new.svg"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import { cleanRedirectLinks, getAsPDPThumbnail, getShortenedUrl, sanitizeInnerHtml } from "@/utils/helper"
import ProductColorFinish from "./ProductColorFinish"
import SelectDropdown from "@/components/core/SelectDropdown/SelectDropdown"
import ProductSize from "./ProductSize"
import StoneTopShelf from "./StoneTopShelf"
import { SELECT_YOUR_STYLE_NOTE } from "@/constants/index";
export const SelectYourStyleView = ({
  authorData = {},
  applyBtn,
  colorFamily,
  closeModal,
  colorHeading = "",
  colors = [],
  colorsPopUp,
  descriptionDetail = "",
  descriptionDetails = "",
  finishFilterChange,
  colorFamilyCount,
  finishSelectedValue = "",
  finishType = [],
  getNewVarients,
  handleShapeSizeSelectChange,
  i18n = {},
  isColor,
  isColorDiscontinued,
  isDiscontinued,
  image,
  isShape,
  modalColorApplyBtn,
  notallowFinishValue,
  openFilter,
  openModal,
  ProductDescriptionDetail = "",
  ProductLocalCategory,
  productTitle,
  selectStyleTooltipHandler,
  setSelectStyleTooltip,
  styleTooltip,
  swatchUrl = "",
  showActivePreview,
  showFilter,
  showModal,
  tooltip = "",
  tooltipdata = {},
  updateLabelHeading,
  updateShapeImagePreview,
  allowMaxColor,
  colorsDiscontinuedVarients = [],
  currentSku,
  finalAvailableColors = [],
  shapeHeading,
  comboSkuDetails = [],
  productCategoryType = "",
  NO_FINISH_TYPE,
  activeSku = "",
  isCollapsedPDP,
  discontinuedCTALink = "",
  presetConfig = {},
  accountName = "",
  productImages = [],
  applySelectedShape,
  styleOptionsNotPresent
}) => {
  const truncateText = (text, maxLength) => text?.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  return (
    <>
      {(isDiscontinued || isColorDiscontinued) && (
        <React.Fragment>
          {colorsDiscontinuedVarients?.length > 0 && (
            <React.Fragment>
              <div className="product-select-style__color product-select-style__discoutinued-main-block">
                <span className="product-select-style__color-label">
                  {i18n.productSelectStyleDiscotinuedLabel}:
                </span>
                <span
                  className="product-select-style__color-text"
                  id="product-select-style__color-text"
                >
                  {currentSku
                    ? colorsDiscontinuedVarients?.length > 0 &&
                      colorsDiscontinuedVarients.map(colorsItem => {
                        return (
                          colorsItem["id"] === currentSku && colorsItem["label"]
                        )
                      })
                    : ""}
                </span>
              </div>
              <div className="product-select-style__color-img-block">
                {colorsDiscontinuedVarients?.length > 0 &&
                  colorsDiscontinuedVarients.map((colorsItem, idx) => {
                    return (
                      colorsItem["id"] === currentSku && (
                        <div
                          className="product-select-style__color-img-outer-block product-select-style__color-img-outer-block-active"
                          key={`colorsDiscontinuedVarients-${idx}`}
                        >
                          <img
                            onError={e => (e.target.src = MissingImage?.src)}
                            src={
                              colorsItem["colorUrl"] 
                                ? colorsItem["colorUrl"] 
                                : MissingImage?.src
                            }
                            className="product-select-style__color-image"
                          />
                        </div>
                      )
                    )
                  })}
              </div>
            </React.Fragment>
          )}
          {isColorDiscontinued && !isDiscontinued ? (
            <div className="product-select-style__discoutinued-block">
              <span className="product-select-style__discoutinued-msg">
                {i18n.productSelectStyleDiscotinuedMsg}
              </span>
              <span className="product-select-style__discoutinued-link-block">
                {finalAvailableColors?.length > 0 &&
                  finalAvailableColors["0"]["skuId"] && (
                    <a
                      href="javascript:void(0)"
                      className="product-select-style__discoutinued-link-lable"
                      onClick={() =>
                        getNewVarients(
                          finalAvailableColors["0"]["skuId"]
                            ? finalAvailableColors["0"]["skuId"]
                            : "",
                          finalAvailableColors["0"],
                          true
                        )
                      }
                    >
                      {i18n.seeAvailableColor}
                    </a>
                  )}
              </span>
            </div>
          ) : isDiscontinued ? (
            <div className="product-select-style__discoutinued-block">
              <span className="product-select-style__discoutinued-msg">
                {i18n.productSelectStyleDiscotinuedMsg}
              </span>
              <span className="product-select-style__discoutinued-link-block">
                <a
                  href={getShortenedUrl(discontinuedCTALink)}
                  className="product-select-style__discoutinued-link-lable"
                >
                  {authorData?.discontinuedCTALabel || i18n.contactShowroom}
                </a>
              </span>
            </div>
          ) : (
            ""
          )}
        </React.Fragment>
      )}
      <ProductColorFinish
        swatchUrl={swatchUrl}
        productTitle={productTitle}
        isDiscontinued={isDiscontinued}
        isColorDiscontinued={isColorDiscontinued}
        isShape={isShape}
        image={image}
        showModal={showModal}
        isColor={isColor}
        colorsPopUp={colorsPopUp}
        ProductLocalCategory={ProductLocalCategory}
        i18n={i18n}
        showActivePreview={showActivePreview}
        updateShapeImagePreview={updateShapeImagePreview}
        closeModal={closeModal}
        modalColorApplyBtn={modalColorApplyBtn}
        openFilter={openFilter}
        applyBtn={applyBtn}
        showFilter={showFilter}
        colorFamily={colorFamily}
        colorFamilyCount={colorFamilyCount}
        activeSku={activeSku}
        presetConfig={presetConfig}
        accountName={accountName}
        productImages={productImages}
        applySelectedShape={applySelectedShape}
        styleOptionsNotPresent={styleOptionsNotPresent}
        selectYourStyleInfo={authorData?.selectYourStyleInfo}
      />
      {!isDiscontinued && !isColorDiscontinued && (
        <React.Fragment>
          {(colors.length > 0 || image.length > 1) && (
            <h2 className="product-select-style__title">
              {authorData && authorData.selectYourStyleTitle
                ? authorData.selectYourStyleTitle
                : i18n.productSelectStyleTitle}
              { styleOptionsNotPresent && 
              (<span
                  className="product-select-style__note"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      cleanRedirectLinks(authorData?.selectYourStyleInfo)
                    ),
                  }}
                />)
              }
            </h2>
          )}
          {isCollapsedPDP && (
            <ProductSize
              comboSkuDetails={comboSkuDetails}
              i18n={i18n}
              swatchUrl={swatchUrl}
              productCategoryType={productCategoryType}
              authorData={authorData}
            />
          )}
          {image.length > 1 && (
            <React.Fragment>
              <div className="product-select-style__shape">
                <div className="product-select-style__shape-label">
                  {authorData && authorData.sizeShapeDesign
                    ? `${authorData.sizeShapeDesign} `
                    : `${i18n.productSelectStyleShapeLabel} `}
                {shapeHeading}
                { image.length >= 7 ? (
                    <span className="product-select-style__shape-count">
                      {" / " + (parseInt(image.length)) + " " + i18n.productSelectStyleShapeTotalOptions}
                    </span>
                  ) : (
                    "")}
                </div>
              </div>
              <>
                {image.length < 7 ? (
                  <div className="product-select-style__shape-img-block" role="radiogroup" aria-label={authorData && authorData.sizeShapeDesign
                    ? authorData.sizeShapeDesign
                    : i18n.productSelectStyleShapeLabel}>
                    {image.length > 0 &&
                      image.map((imageItem, i) => {
                        const activeImageItem = image.find(
                          imageItem => imageItem["isActive"]
                        )
                        const shapeImage = imageItem["src"] && imageItem["src"]
                        const urlParts = shapeImage && shapeImage?.split("/")
                        const imageId =
                          urlParts && urlParts[urlParts?.length - 1]
                        const updatedImageWithPreset =
                          shapeImage &&
                          getAsPDPThumbnail(
                            swatchUrl,
                            presetConfig,
                            imageId,
                            accountName
                          )
                        return (
                          <button 
                            key={i}
                            aria-label={imageItem["name"]}
                            onClick={() =>
                                handleShapeSizeSelectChange(
                                  imageItem["name"],
                                  imageItem["src"]
                                )
                              }
                              onMouseOver={() =>
                                updateLabelHeading(
                                  "product-select-style__shape-text",
                                  imageItem["name"]
                                )
                              }
                              onMouseLeave={() =>
                                updateLabelHeading(
                                  "product-select-style__shape-text",
                                  activeImageItem["name"]
                                )
                              }
                              role="radio"
                              aria-checked={imageItem["isActive"] === true}
                              className="product-select-style__shape-button"
                          >
                            <img
                              onError={e => (e.target.src = MissingImage?.src)}
                              src={updatedImageWithPreset ?? MissingImage?.src}
                              aria-hidden="true"
                              alt={imageItem["name"]}
                              className={
                                imageItem["isActive"] === true
                                  ? "product-select-style__shape-image product-select-style__shape-image-active"
                                  : "product-select-style__shape-image"
                              }
                            />
                          </button>
                        )
                      })}
                    <span role="tooltip">
                      <img
                        src={tooltip?.src}
                        onMouseOver={() =>
                          selectStyleTooltipHandler(
                            true,
                            false,
                            false,
                            false,
                            tooltipdata?.ProductDetailImageURL_s
                          )
                        }
                        onFocus={() =>
                          selectStyleTooltipHandler(
                            true,
                            false,
                            false,
                            false,
                            tooltipdata?.ProductDetailImageURL_s
                          )
                        }
                        onMouseLeave={() =>
                          setSelectStyleTooltip({
                            shareTooltip: false,
                            colorTooltip: false,
                            finishTooltip: false,
                            vanityTooltip: false,
                          })
                        }
                        onBlur={() =>
                          setSelectStyleTooltip({
                            shareTooltip: false,
                            colorTooltip: false,
                            finishTooltip: false,
                            vanityTooltip: false,
                          })
                        }
                        tabIndex="0"
                        className="product-select-style__shape-tooltip"
                        aria-describedby="tooltip-message"
                      />
                      {tooltipdata?.ProductDetailImageURL_s && (
                        <div
                          id="tooltip-message"
                          className={`product-select-style__list-tooltip${
                            styleTooltip.shareTooltip ? "--show" : "--hide"
                          }`}
                        >
                          <div className="product-select-style__list-tooltip-wrapper">
                            <ToolTip
                              message={tooltipdata.ProductDetailImageURL_s}
                            />
                          </div>
                        </div>
                      )}
                    </span>
                  </div>
                ) : (
                  <div className="product-select-style__color-custom-block product-select-style-shape">
                    <div
                      className="product-select-style__color-custom-select-block mb-20"
                      onClick={() => openModal("shape")}
                    >
                      <ul className="product-select-style__shape-ul p-0 m-0">
                        {image.length > 0 &&
                          image.map((imageItem, i) => {
                            return (
                              imageItem["isActive"] === true && (
                                <li
                                  key={`imageItem-${i}`}
                                  className="product-select-style__shape-li"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="product-select-style__shape-link"
                                  >
                                    <img
                                      onError={e =>
                                        (e.target.src = MissingImage?.src)
                                      }
                                      src={imageItem["src"]}
                                      className="product-select-style__shape-select-option-img"
                                    />
                                    <span className="product-select-style__shape-sub-heading">
                                      {imageItem["name"]}
                                    </span>
                                  </a>
                                  <img
                                    onError={e =>
                                      (e.target.src = MissingImage?.src)
                                    }
                                    src={arrowDown?.src}
                                    className="product-select-style__shape-arrow-down-img"
                                  />
                                </li>
                              )
                            )
                          })}
                      </ul>
                    </div>
                    <div className="product-select-style__shape-select-tooltip-block">
                      <img
                        src={tooltip?.src}
                        className="product-select-style__shape-select-tooltip"
                        onMouseOver={() =>
                          selectStyleTooltipHandler(
                            true,
                            false,
                            false,
                            false,
                            tooltipdata?.ProductDetailImageURL_s
                          )
                        }
                        onMouseLeave={() =>
                          setSelectStyleTooltip({
                            shareTooltip: false,
                            colorTooltip: false,
                            finishTooltip: false,
                            vanityTooltip: false,
                          })
                        }
                      />
                      {tooltipdata?.ProductDetailImageURL_s && (
                        <div
                          className={`product-select-style__list-tooltip${
                            styleTooltip.shareTooltip ? "--show" : "--hide"
                          }`}
                        >
                          <div className="product-select-style__list-tooltip-color-wrapper">
                            <ToolTip
                              message={tooltipdata.ProductDetailImageURL_s}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            </React.Fragment>
          )}
          <>
            {colors.length > 0 && (
              <React.Fragment>
                <div
                  className={
                    finishType.length <= notallowFinishValue
                      ? "product-select-style__color color-finish"
                      : "product-select-style__color"
                  }
                >
                  <div className="product-select-style__color-label">
                    {authorData && authorData.color
                      ? authorData.color
                      : finishType.length <= notallowFinishValue ?
                        `${i18n.productSelectStyleColorLabel}/${i18n.productSelectStyleFinishLabel}` :
                        i18n.productSelectStyleColorLabel
                    }: {colorHeading}
                    {finishType.length > notallowFinishValue && colors.length > allowMaxColor && (
                      <span className="product-select-style__color-count">
                        {` / ${colors.length} ${i18n.productSelectStyleShapeTotalOptions}`}
                      </span>
                    )}
                  </div>
                </div>
                {colors.length < allowMaxColor ? (
                  <div className="product-select-style__color-img-block" role="radiogroup" aria-label={authorData && authorData.color
                    ? authorData.color
                    : finishType.length <= notallowFinishValue ?
                      `${i18n.productSelectStyleColorLabel}/${i18n.productSelectStyleFinishLabel}` :
                      i18n.productSelectStyleColorLabel
                  }>
                    {colors.length > 0 &&
                      colors.map((colorsItem, i) => {
                        const activeColorItem = colors.find(
                          color => color["isActive"] === true
                        )
                        const colorImage =
                          colorsItem["src"] && colorsItem["src"]
                        const urlParts = colorImage && colorImage?.split("/")
                        const imageId =
                          urlParts && urlParts[urlParts?.length - 1]
                        const updatedColorImageWithPreset =
                          colorImage &&
                          getAsPDPThumbnail(
                            swatchUrl,
                            presetConfig,
                            imageId,
                            accountName
                          )
                        return (
                          <div
                            key={i}
                            role="radio"
                            className={
                              colorsItem["isActive"] === true
                                ? "product-select-style__color-img-outer-block product-select-style__color-img-outer-block-active"
                                : "product-select-style__color-img-outer-block"
                            }
                            onClick={() =>
                              getNewVarients(
                                colorsItem["skuId"] ? colorsItem["skuId"] : "",
                                colorsItem,
                                true
                              )
                            }
                            onMouseOver={() =>
                              updateLabelHeading(
                                "product-select-style__color-text",
                                `${colorsItem["name"]} ${
                                  colorsItem["finishName"] !== NO_FINISH_TYPE
                                    ? ` - ${colorsItem["finishName"]}`
                                    : ""
                                }`
                              )
                            }
                            onMouseLeave={() => {
                              let colorItem = activeColorItem ? activeColorItem : colorsItem
                              updateLabelHeading(
                                "product-select-style__color-text",
                                `${colorItem["name"]} ${
                                  colorItem["finishName"] !==
                                  NO_FINISH_TYPE
                                    ? ` -  ${colorItem["finishName"]}`
                                    : ""
                                }`
                              )
                            }
                            }
                            aria-checked={colorsItem["isActive"] === true}
                            tabIndex="0"
                          >
                            <img
                              onError={e => (e.target.src = MissingImage?.src)}
                              src={
                                updatedColorImageWithPreset ?? MissingImage?.src
                              }
                              className="product-select-style__color-image"
                              alt={`Color is ${colorsItem["name"]} ${
                                colorsItem["finishName"]}`}
                              tabIndex="0"
                            />
                          </div>
                        )
                      })}
                    <span role="tooltip">
                      <img
                        src={tooltip?.src}
                        className="product-select-style__color-tooltip"
                        tabIndex={0}
                        onMouseOver={() =>
                          selectStyleTooltipHandler(
                            false,
                            true,
                            false,
                            false,
                            tooltipdata["Color.Name"]
                          )
                        }
                        onFocus={() =>
                          selectStyleTooltipHandler(
                            false,
                            true,
                            false,
                            false,
                            tooltipdata["Color.Name"]
                          )
                        }
                        onMouseLeave={() =>
                          setSelectStyleTooltip({
                            shareTooltip: false,
                            colorTooltip: false,
                            finishTooltip: false,
                            vanityTooltip: false,
                          })
                        }
                        onBlur={() =>
                          setSelectStyleTooltip({
                            shareTooltip: false,
                            colorTooltip: false,
                            finishTooltip: false,
                            vanityTooltip: false,
                          })
                        }
                        aria-describedby="tooltip-color-message"
                      />
                      {tooltipdata && tooltipdata["Color.Name"] && (
                        <div
                          id="tooltip-color-message"
                          className={`product-select-style__list-tooltip${
                            styleTooltip.colorTooltip ? "--show" : "--hide"
                          }`}
                        >
                          <div className="product-select-style__list-tooltip-color-wrapper">
                            <ToolTip message={tooltipdata["Color.Name"]} />
                          </div>
                        </div>
                      )}
                    </span>
                  </div>
                ) : (
                  <div
                    className={
                      colors.length >= allowMaxColor
                        ? "product-select-style__color-custom-block product-select-style-color product-color-dropdown"
                        : "product-select-style__color-custom-block product-select-style-color"
                    }
                  >
                    <div
                      className="product-select-style__color-custom-select-block"
                      onClick={() => openModal("color")}
                    >
                      <ul className="product-select-style__color-ul p-0 m-0">
                        {colors.length > 0 &&
                          colors.map((colorsItem, idx) => {
                            const colorsItemImage =
                              colorsItem["src"] && colorsItem["src"]
                            const urlParts =
                              colorsItemImage && colorsItemImage?.split("/")
                            const imageId =
                              urlParts && urlParts[urlParts?.length - 1]
                            const updatedColorsImageWithPreset =
                              colorsItemImage &&
                              getAsPDPThumbnail(
                                swatchUrl,
                                presetConfig,
                                imageId,
                                accountName
                              )
                            return (
                              colorsItem["isActive"] === true && (
                                <li
                                  key={`colors-${idx}`}
                                  className="product-select-style__color-li"
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="product-select-style__color-link"
                                  >
                                    <div className="product-select-style__color-select-option-img-block">
                                      <img
                                        onError={e =>
                                          (e.target.src = MissingImage?.src)
                                        }
                                        src={
                                          updatedColorsImageWithPreset ??
                                          MissingImage?.src
                                        }
                                        className="product-select-style__color-select-option-img"
                                      />
                                    </div>
                                    <span className="product-select-style__color-sub-heading">
                                      {colorsItem["finishName"] !== NO_FINISH_TYPE
                                        ? truncateText(`${colorsItem["name"]} - ${colorsItem["finishName"]}`, 30)
                                        : truncateText(colorsItem["name"], 30)
                                      }
                                    </span>
                                  </a>
                                  <img
                                    onError={e =>
                                      (e.target.src = MissingImage?.src)
                                    }
                                    src={arrowDown?.src}
                                    className="product-select-style__color-arrow-down-img"
                                  />
                                </li>
                              )
                            )
                          })}
                      </ul>
                    </div>
                    <div className="product-select-style__color-select-tooltip-block">
                      <img
                        src={tooltip?.src}
                        onMouseOver={() =>
                          selectStyleTooltipHandler(
                            false,
                            true,
                            false,
                            false,
                            tooltipdata["Color.Name"]
                          )
                        }
                        onMouseLeave={() =>
                          setSelectStyleTooltip({
                            shareTooltip: false,
                            colorTooltip: false,
                            finishTooltip: false,
                            vanityTooltip: false,
                          })
                        }
                        className="product-select-style__color-select-tooltip"
                      />
                      {tooltipdata && tooltipdata["Color.Name"] && (
                        <div
                          className={`product-select-style__list-tooltip${
                            styleTooltip.colorTooltip ? "--show" : "--hide"
                          }`}
                        >
                          <div className="product-select-style__list-tooltip-color-wrapper">
                            <ToolTip message={tooltipdata["Color.Name"]} />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </>
          <>
            {finishType?.length > 0 ? (
              <React.Fragment>
                {finishType?.length > 1 && (
                  <>
                    <div className="product-select-style__finish">
                      <label className="m-0" htmlFor="finish-select">
                        <span className="product-select-style__finish-label">
                          {i18n.productSelectStyleFinishLabel}:
                        </span>
                        <span
                          className="product-select-style__finish-text"
                          id="product-select-style__finish-text"
                        >
                          {finishSelectedValue}
                        </span>
                        {finishType?.length > 1 && (
                          <span className="product-select-style__finish-count">
                            {" / " + (parseInt(finishType?.length) - 1) + " " + i18n.productSelectStyleShapeTotalOptions}
                          </span>
                        )}
                      </label>
                    </div>
                    <div className="product-select-style__finish-form">
                      <form className="form">
                        <SelectDropdown
                          id="finish-select"
                          data={finishType}
                          value={finishSelectedValue}
                          onChange={val => finishFilterChange(val)}
                          label="finish-select"
                        />
                        <img
                          src={tooltip?.src}
                          onMouseOver={() =>
                            selectStyleTooltipHandler(
                              false,
                              false,
                              true,
                              false,
                              tooltipdata["colorFinishFamilyList_ss"]
                            )
                          }
                          onMouseLeave={() =>
                            setSelectStyleTooltip({
                              shareTooltip: false,
                              colorTooltip: false,
                              finishTooltip: false,
                              vanityTooltip: false,
                            })
                          }
                          className="product-select-style__finish-tooltip"
                        />
                        {tooltipdata &&
                          tooltipdata["colorFinishFamilyList_ss"] && (
                            <div
                              className={`product-select-style__list-tooltip${
                                styleTooltip.finishTooltip ? "--show" : "--hide"
                              }`}
                            >
                              <div className="product-select-style__list-tooltip-color-wrapper">
                                <ToolTip
                                  message={
                                    tooltipdata["colorFinishFamilyList_ss"]
                                  }
                                />
                              </div>
                            </div>
                          )}
                      </form>
                    </div>
                  </>
                )}
              </React.Fragment>
            ) : null}
          </>

          <StoneTopShelf
            i18n={i18n}
            authorData={authorData}
            comboSkuDetails={comboSkuDetails}
            swatchUrl={swatchUrl}
            productCategoryType={productCategoryType}
            selectStyleTooltipHandler={selectStyleTooltipHandler}
            setSelectStyleTooltip={setSelectStyleTooltip}
            tooltipdata={tooltipdata}
            styleTooltip={styleTooltip}
            currentSku={currentSku}
          />
        </React.Fragment>
      )}
    </>
  )
}
export default SelectYourStyleView
